export const formatPopulation = (pop) =>
  new Intl.NumberFormat("locale").format(pop);
